import * as React from "react";
const SvgBrackets = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.108 17.714V13.57l-.84-.84a1.034 1.034 0 0 1 0-1.462l.84-.841V6.286a3.32 3.32 0 0 1 3.32-3.321 1.035 1.035 0 0 1 0 2.07 1.25 1.25 0 0 0-1.25 1.251v4.571c0 .275-.109.538-.303.732L3.463 12l.412.411c.194.194.303.457.303.732v4.57c0 .692.56 1.252 1.25 1.252a1.035 1.035 0 0 1 0 2.07 3.32 3.32 0 0 1-3.32-3.321m17.714 0v-4.571c0-.275.109-.538.303-.732l.411-.411-.411-.411a1.03 1.03 0 0 1-.303-.732v-4.57c0-.692-.56-1.252-1.25-1.252a1.035 1.035 0 0 1 0-2.07 3.32 3.32 0 0 1 3.32 3.321v4.142l.84.84a1.034 1.034 0 0 1 0 1.463l-.84.84v4.143a3.32 3.32 0 0 1-3.32 3.321 1.035 1.035 0 0 1 0-2.07c.69 0 1.25-.56 1.25-1.251"
}));
export default SvgBrackets;
//# sourceMappingURL=Brackets.js.map